export default class ProjectsFormulationListCtrl {

  constructor ($scope, $timeout, WorkPlanSrv, WorkPlanModalSrv, $mdDialog, $cookies, $stateParams, $state, GlobalConfig, Requests, $sessionStorage) {
    var projectsFormulationVm = this;    

    projectsFormulationVm.mainLabel = 'Formación doctoral'
    projectsFormulationVm.viewLoaded = false
    projectsFormulationVm.projectList = []
    const currentUser = JSON.parse($cookies.get('currentUser'))
    let post = {
        workplanId: currentUser.workplanId,
        teacherId: currentUser.teacherId,
      }
    
    projectsFormulationVm.imgEmpty = require('../../../../../../assets/images/empty_state_illustration.svg')

    //VARIABLES
    projectsFormulationVm.active = GlobalConfig.generals.active
    projectsFormulationVm.notActive = GlobalConfig.generals.notActive
    projectsFormulationVm.planningFinish = true
    $scope.classPlanning = ''
    projectsFormulationVm.feedback = 0
    projectsFormulationVm.workPlanGeneralList = $sessionStorage.workPlanGeneralList
    projectsFormulationVm.$sessionStorage = $sessionStorage
    
    //METHODS
    projectsFormulationVm.backgroundGrad = backgroundGrad
    projectsFormulationVm.updateView = updateView
    projectsFormulationVm.loadData = loadData
    projectsFormulationVm.getGeneralsWorkplan = getGeneralsWorkplan
    projectsFormulationVm.close = close
    projectsFormulationVm.confirmDeleteProject = confirmDeleteProject
    projectsFormulationVm.bitacora = bitacora

    function backgroundGrad (index) {
      let result = 'grad-oblique-'

      switch (index % 4) {
        case 0:
          return result + 'negro-dark'
        case 1:
          return result + 'azul'
        case 2:
          return result + 'teal'
        case 3:
          return result + 'deep-orange'
        default:
          return result + 'negro-dark'
      }
    }

    activate()

    function activate() {
      if(projectsFormulationVm.workPlanGeneralList != undefined){
        projectsFormulationVm.status = projectsFormulationVm.workPlanGeneralList.wokplanTeacherStatus[0]
        projectsFormulationVm.stages = projectsFormulationVm.workPlanGeneralList.stages
        projectsFormulationVm.feedback = projectsFormulationVm.status.feedbackReviewed
        projectsFormulationVm.workplanTeacherId = projectsFormulationVm.status.workplanTeacherId
        isPlanning(projectsFormulationVm.status, projectsFormulationVm.stages)
      
        if(projectsFormulationVm.feedback && !projectsFormulationVm.planningFinish){
          getListProjectsFormulatedReject()
        }else{
          getListProjectsFormulated()
        }
      }else{
        getGeneralsWorkplan(post).then((promise) => {
          if(projectsFormulationVm.feedback && !projectsFormulationVm.planningFinish){
            getListProjectsFormulatedReject()
          }else{
            getListProjectsFormulated()
          }
        })
      }

      updateView()
    }

    function getListProjectsFormulated(){
      WorkPlanSrv.getListProjectsFormulated.getList(post).$promise.then(
        dataReturn => {
          if (dataReturn.status) {
            loadData(dataReturn.listProjects)
          }else{
            console.log("Comunications problem")
          }
        },
        data => {
          console.log(data)
        }
      )
    }

    function getListProjectsFormulatedReject(){
      WorkPlanSrv.getListProjectsFormulatedReject.getList(post).$promise.then(
        dataReturn => {
          if (dataReturn.status) {
            loadData(dataReturn.listProjects)
          }else{
            console.log("Comunications problem")
          }
        },
        data => {
          console.log(data)
        }
      )
    }

    function loadData(data) {
      projectsFormulationVm.projectList = data
      for (var i = projectsFormulationVm.projectList.length - 1; i >= 0; i--) {
        if(projectsFormulationVm.projectList[i].timeRangeTypeId == GlobalConfig.periods.rangeType)
          projectsFormulationVm.projectList[i].periods = data[i].periodName.split(',')
      }

    }

    function updateView () {
      projectsFormulationVm.viewLoaded = false
      $timeout(() => {
        projectsFormulationVm.viewLoaded = true
      }, 1)
    }

    function getGeneralsWorkplan(post){
      return WorkPlanSrv.getElementsRightBar.getList({teacherId: post.teacherId}).$promise.then(function(dataReturn) {
        if(dataReturn.status){
          projectsFormulationVm.$sessionStorage.workPlanGeneralList = dataReturn.data
          projectsFormulationVm.status = dataReturn.data.wokplanTeacherStatus[0]
          projectsFormulationVm.stages = dataReturn.data.stages
          projectsFormulationVm.feedback = projectsFormulationVm.status.feedbackReviewed
          projectsFormulationVm.workplanTeacherId = projectsFormulationVm.status.workplanTeacherId
          isPlanning(projectsFormulationVm.status, projectsFormulationVm.stages)
        }else{
          console.log("Comunications problem with the server")
        }
      },function(data) {
           console.log(data);
      })
    }

    function isPlanning(status, stages){
      projectsFormulationVm.currentDate = moment(new Date()).format("DD/MM/YYYY")
      for (var i = stages.length - 1; i >= 0; i--) {
        if(stages[i].stageId == GlobalConfig.workplanIdStages.review){
          projectsFormulationVm.startDateStage = stages[i].startDate
        }
      }

      if(status.workplanActive){
        if (status.planningFinish == projectsFormulationVm.active) {
          projectsFormulationVm.planningFinish = true
          if (projectsFormulationVm.startDateReview < projectsFormulationVm.currentDate || status.reviewedFinish == projectsFormulationVm.active){
            projectsFormulationVm.planningFinish = true
          } else if (status.reviewedReject == projectsFormulationVm.active){
            projectsFormulationVm.planningFinish = false
          }
        } else {
          projectsFormulationVm.planningFinish = false
        }
      }else{
        projectsFormulationVm.planningFinish = true
        projectsFormulationVm.workplanActive = true
      }

      $scope.classPlanning = (projectsFormulationVm.planningFinish ? "disabled" : " ")
    }

    function confirmDeleteProject (project) { 
      let projectName = project.nameProject
      let projectId = project.workplanTeacherActivityId

      $mdDialog.show({
        controller: ['$scope', '$mdDialog', 'WorkPlanIndicatorSrv', function ($scope, $mdDialog, WorkPlanIndicatorSrv) {
          let ctrlModalVM = this
          ctrlModalVM.projectName = projectName
          ctrlModalVM.projectId = projectId
          ctrlModalVM.close = function () {
            $mdDialog.hide()
          }
          ctrlModalVM.deleteProject = function () {
            let requestHeader = {workplanTeacherActivityId: ctrlModalVM.projectId }
            WorkPlanSrv.disableActivityResearch.delete(requestHeader)
            .$promise.then(function (dataReturn) {
              if (dataReturn.status) {
                removeFromCaroussel(project)
                showDeletedSuccessfully(ctrlModalVM.projectName)
                WorkPlanIndicatorSrv.setVariable(true)
                $mdDialog.hide()
              } else {
                console.log('Comunications problem with the server')
              }
            }, function (data) {

            })
          }
        }],
        controllerAs: 'ctrlModalVM',
        template: require('./deleteProjectModal.html'),
        clickOutsideToClose: false
      })
    }

    function showDeletedSuccessfully(projectName){
      let texts = GlobalConfig.appTexts
      let header = {
        createOrEdit     : texts.deleteDialog,
        textCreateOrEdit : texts.deleted,
        itemName         : projectName,
        nameModal        : texts.modalTypeName.deleted,
        modalType        : texts.modalTypeId.default
      }
      WorkPlanModalSrv.setVariableSuccessDialog(header)
      WorkPlanModalSrv.successDialog(header).then((promise) => { })
    }

    function removeFromCaroussel(project){
      for(var i in projectsFormulationVm.projectList){
        if(projectsFormulationVm.projectList[i].workplanTeacherActivityId === project.workplanTeacherActivityId){
          projectsFormulationVm.projectList.splice(i,1)
          updateView()
          break
        }
      }
    }

    function close (){
      $mdDialog.hide()
    }

    function bitacora (ev) {
      let entries = {}

      entries.params = {
        activityTypeId: GlobalConfig.activityTypeId.projectDesign,
        workplanTeacherId: projectsFormulationVm.workplanTeacherId
      }
      entries.title = 'Formulación de propuestas'
      // Entries(this.entries);
      entries.data = undefined
      $mdDialog.show({
        controller: 'bitacoraModalCtrl',
        controllerAs: 'bit',
        template: require('../../../../strategicTracking/detailsByTeacher/bitacoraModal/bitacoraModal.html'),
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: {data: entries},
        clickOutsideToClose: true,
        fullscreen: true
      })
    }

  }
}

ProjectsFormulationListCtrl.$inject = ['$scope', '$timeout', 'WorkPlanSrv', 'WorkPlanModalSrv', '$mdDialog', '$cookies', '$stateParams', '$state', 'GlobalConfig', 'Requests', '$sessionStorage']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/research/projectsFormulation/list/projectsFormulationListCtrl.js